import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { setMessage } from "./message";

import ManagerService from "../../services/manager.service";

const user = JSON.parse(localStorage.getItem("user"));


export const getProfile = createAsyncThunk(
  "auth/user/",
  async(thunkAPI) => {
    try {
      const response = await ManagerService.getProfile();
      // console.log('Profile', response[0])
      return response[0];
    } catch (error) {
      console.log(error)
      return error
    }
  }
)

export const verification = createAsyncThunk(
  "auth/verify/",
  async ({ email, otp }, thunkAPI) => {
    try {
      const payload = { email, otp }
      const response = await ManagerService.verification(payload);
      thunkAPI.dispatch(setMessage({message: response.message, status: 'True'}));
      thunkAPI.dispatch(memberAuthSlice.actions.setVerificationStatus(response.data))
      return response.data;
    } catch (error) { 
      console.log(error)
      const message =
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage({message: message, status: error.status || error.success}));
      thunkAPI.dispatch(memberAuthSlice.actions.hasError(error))
      return thunkAPI.rejectWithValue();
    }
  }
);

export const resendOtp = createAsyncThunk(
  "auth/re_verify/",
  async ({ email }, thunkAPI) => {
    try {
      const payload = { email }
      const response = await ManagerService.resendOtp(payload);
      thunkAPI.dispatch(setMessage(response.data.message));
      return response.data;
    } catch (error) { 
      console.log(error)
      const message =
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage({message: message, status: error.status || error.success}));
      thunkAPI.dispatch(memberAuthSlice.actions.hasError(error))
      return thunkAPI.rejectWithValue();
    }
  }
);

export const forgotPassword = createAsyncThunk(
  "/members/forgot-password/",
  async (payload, thunkAPI) => {
    try {
      // const payload = { email }
      const response = await ManagerService.forgotPassword(payload);
      // console.log(response)
      thunkAPI.dispatch(setMessage({message: response.message, status: 'True'}));
      return response;
    } catch (error) { 
      console.log(error)
      const message =
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage({message: message, status: error.status || error.success}));
      thunkAPI.dispatch(memberAuthSlice.actions.hasError(error))
      return error
    }
  }
);

export const resetPassword = createAsyncThunk(
  "/members/forgot_password_validate/",
  async ({ email, password, otp }, thunkAPI) => {
    try {
      const payload = { email, password, otp }
      const response = await ManagerService.resetPassowrd(payload);
      // console.log(response)
      thunkAPI.dispatch(setMessage({message: response.message, status: 'True'}));
      return response;
    } catch (error) { 
      console.log(error)
      const message =
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage({message: message, status: error.status || error.success}));
      thunkAPI.dispatch(memberAuthSlice.actions.hasError(error))
      return error
    }
  }
);

export const login = createAsyncThunk(
  "member/login/",
  async ({ email, password }, thunkAPI) => {
    try {
      const payload = { email, password }
      const response = await ManagerService.login(payload);
      thunkAPI.dispatch(memberAuthSlice.actions.setAuthStatus(response.data))
      return response;
    } catch (error) {
        // console.log(error)
        const message =
        error.message ||
        error.toString();
        thunkAPI.dispatch(setMessage({message: message, status: 'False' }));
      return error;
      return thunkAPI.rejectWithValue();
    }
  }
);

export const changeAccountPassword = createAsyncThunk(
  '/members/change_password/',
  async(payload, thunkAPI) => {
    try {
        const response = await ManagerService.changePassword(payload)
        return response
      } catch (error) {
        console.log(error)
        return error
    }
  }
)

// **** PETTY CASH *** \\
export const managerGetPettyWallet = createAsyncThunk(
  '/members/petty_cash_wallet/',
  async(_, thunkAPI) => {
      try {
          const response = await ManagerService.getPettyCashWalletDetails()
          return response
      } catch (error) {
        return error
      }
  }
)

export const managerAddPettyBeneficiary = createAsyncThunk(
  '/members/petty_cash_beneficiary/',
  async(payload, thunkAPI) => {
      try {
          const response = await ManagerService.createPettyCashBeneficary(payload)
          return response
      } catch (error) {
        return error
      }
  }
)

export const managerGetPettyBeneficaries = createAsyncThunk(
  '/members/petty_cash_beneficiaries/',
  async(_, thunkAPI) => {
      try {
          const response = await ManagerService.getPettyCashBeneficaries()
          return response
      } catch (error) {
        return error
      }
  }
)

export const managerPayPettyBeneficiary = createAsyncThunk(
  '/members/pay_beneficiary/',
  async(payload, thunkAPI) => {
      try {
          const response = await ManagerService.payPettyCashBeneficary(payload)
          return response
      } catch (error) {
        return error
      }
  }
)

export const managerManagePettyRequest = createAsyncThunk(
  '/members/petty_cash_request/',
  async(payload, thunkAPI) => {
      try {
          const response = await ManagerService.managePettyCashRequest(payload)
          return response
      } catch (error) {
        return error
      }
  }
)

export const managerGetPettyRequest = createAsyncThunk(
  '/members/petty_cash_request/',
  async(_, thunkAPI) => {
      try {
          const response = await ManagerService.getPettyCashRequests()
          return response
      } catch (error) {
        return error
      }
  }
)

export const managerSubmitPettyRequest = createAsyncThunk(
  '/members/petty_cash_request/',
  async(payload, thunkAPI) => {
      try {
          const response = await ManagerService.submitPettyCashRequest(payload)
          return response
      } catch (error) {
        return error
      }
  }
)

export const managerGetPettyWalletLog = createAsyncThunk(
  '/members/petty_cash_wallet_log/',
  async(payload, thunkAPI) => {
      try {
        return await ManagerService.getPettyCashWalletLogs(payload)
      } catch (error) {
        return error
      }
  }
)

export const managerDownloadPettyCashLog = createAsyncThunk(
  '/members/petty_cash_wallet_log/',
  async(_, thunkAPI) => {
      try {
        return await ManagerService.downloadPettyCashLog()
      } catch (error) {
        return error
      }
  }
)

export const logout = createAsyncThunk(
  "auth/logout", 
  async (_, thunkAPI) => {
    thunkAPI.dispatch(memberAuthSlice.actions.signOut())
    return true
  });

  export const logoutManager = createAsyncThunk(
    "auth/logout",  
    async (_, thunkAPI) => {
      thunkAPI.dispatch(memberAuthSlice.actions.signOut())
      return true
    }
  );

const initialState =
 { 
    isLoggedIn: false, 
    user: null, 
    isLoading: false,
    error: null,
    isManager: false,
    isPinCreated: false,
  };

const memberAuthSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    hasError(state, action) {
      state.isLoading = false
      state.error = action.payload
    },
    startLoading(state) {
      state.isLoading = true
    },
    getSignupSuccess(state, action) {
      // delete action.payload.token
      state.user = action.payload
      state.isAccountCreated = true
      state.isOtpVerified = false
    },
    setVerificationStatus(state, action) {
      state.isOtpVerified = true
      state.isAccountCreated = true
      state.isLoading = false
      localStorage.setItem('tkn', action.payload.token)
      state.user = action.payload
      state.isPinCreated = action.payload.pin_set
    },
    setAuthStatus(state, action) {
      state.isLoggedIn = true
      state.isManager = true
      localStorage.setItem('tkn', action.payload.token)
      state.user = action.payload
      state.isPinCreated = action.payload.pin_set
    },
    setToken(state, action) {
      localStorage.setItem("tkn", action.payload); 
    },
    signOut(state) {
      state.isLoggedIn = false
      state.isManager = false
      state.user = null
      state.isPinCreated = false
      localStorage.removeItem('tkn') 
      localStorage.removeItem('invLogin')
      localStorage.removeItem('invhash')
      localStorage.removeItem("redux-inventory")
      localStorage.removeItem("redux-business")
    },
    setUser(state, action) {
      state.user = action.payload;
    }

  },
  extraReducers: {
    [logout.fulfilled]: (state, action) => {
      state.isLoggedIn = false;
      state.isManager = false;
      state.user = null
      localStorage.removeItem('tkn')
      localStorage.removeItem('invLogin')
      localStorage.removeItem('invhash')
      localStorage.removeItem("redux-inventory")
      localStorage.removeItem("redux-business")
    },
    [getProfile.fulfilled]: (state, action) => {
      state.user = action.payload
    },
    // [login.fulfilled]: (state, action) => {
    //   state.user = action.payload.data ?? ''
    //   state.isLoggedIn = true
    //   state.isManager = false
    //   if(action.payload.data?.token) {
    //     localStorage.setItem('token', action.payload?.data?.token)
    //   }
    //   else {
    //     localStorage.removeItem('token')
    //   }
    // }
  },
});

const { reducer } = memberAuthSlice;
export default reducer;